/** Detect Instagram / Facebook / TikTok (and related) in-app browsers. */
const IN_APP_UA =
  /Instagram|FBAN|FBAV|FB_IAB|Messenger|TikTok|BytedanceWebview|TTWebView|musical_ly/i;

export function isInAppBrowser(ua: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''): boolean {
  return IN_APP_UA.test(ua);
}

export function isAndroid(ua: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''): boolean {
  return /android/i.test(ua);
}

export function isIos(ua: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''): boolean {
  return /iPad|iPhone|iPod/i.test(ua) ||
    (typeof navigator !== 'undefined' &&
      navigator.platform === 'MacIntel' &&
      navigator.maxTouchPoints > 1);
}

/** Homepage should show the /get bridge instead of the marketing site. */
export function shouldShowGetBridge(ua?: string): boolean {
  return isInAppBrowser(ua) || isAndroid(ua);
}
